import * as _ from 'lodash';
import {dayJS} from "../../../applicationConf";

//****************** conversione mappa response in mappa Javascript e viceversa ***************
export const convertObjectToMap = (obj) => {
    const map = new Map();
    Object.keys(obj).forEach(key => map.set(key, obj[key]));
    return map;
};

export const convertMapToObject = (map) => {
    const _mapObj = {};
    try {
        map.forEach((value, key) => {
            _mapObj[key] = value
        });
    } catch (e) {
        console.log('commonFunctions.js -> convertMapToObject :: ', e)
    }

    return _mapObj;
};
//****************** conversione mappa response in mappa Javascript e viceversa ***************

//**************** crea DropDawnList dei giorni della settimana *****************************
export const listaGiorniSettimana = (startDay, endDay) => {
    if (startDay != null && startDay !== '' && endDay != null && endDay !== '') {
        // +1 per includere la data di inizio
        const diff = dayJS(endDay, 'YYYY-MM-DD').diff(startDay, 'days') + 1;

        switch (true) {
            case diff >= 7 : {
                return totalDaysOfWeek();
            }
            case diff === 1 : {
                const day = dayJS().isoWeekday(dayJS(startDay, 'YYYY-MM-DD').isoWeekday()).format('dddd');
                const value = (dayJS(startDay, 'YYYY-MM-DD').isoWeekday()).toString();
                return Array.of({
                    value,
                    displayValue: day.charAt(0).toUpperCase() + day.slice(1)
                });
            }
            case diff > 0 && diff < 7 : {
                return Array.apply(null, {length: diff})
                    // parto dal numero della settimana di oggi, lo comprendo con +1 e incremento il giorno fino ad arrivare alla fine dei giorni disponibili indicati da diff
                    .map((_, i) => dayJS().isoWeekday(dayJS(startDay, 'YYYY-MM-DD').isoWeekday() + i).format('dddd'))
                    .reduce((accumulator, day, currentIndex) => {
                        accumulator.push({
                            value: day !== 'domenica' ? dayJS().isoWeekday(dayJS(startDay, 'YYYY-MM-DD').isoWeekday() + currentIndex).format('d') : '7',
                            displayValue: day.charAt(0).toUpperCase() + day.slice(1)
                        });
                        return accumulator;
                    }, []);
            }

            default : {
                return []
            }
        }

    } else {
        return totalDaysOfWeek();
    }
};

const totalDaysOfWeek = () => {
    return Array.apply(null, {length: 7})
        .map((_, i) => dayJS().isoWeekday(i + 1).format('dddd'))
        .reduce((accumulator, day, currentIndex) => {
            accumulator.push({
                value: day !== 'domenica' ? dayJS().isoWeekday(currentIndex + 1).format('d') : '7',
                displayValue: day.charAt(0).toUpperCase() + day.slice(1)
            });
            return accumulator;
        }, []);
};
//**************** crea DropDawnList dei giorni della settimana *****************************

//**************** funzioni per calcolare le ore previste nel profilo orario *****************
export const calcolaTempo = (tempo) => {
    return `${Math.floor(tempo / 60)} Ore ${tempo % 60 > 0 ? tempo % 60 + ' minuti' : ''}`
};

export const calcolaTempoTotale = (profiloOrario) => {
    let sum = 0;
    if (!_.isEmpty(profiloOrario)) {

        const mapGiornaliero = convertObjectToMap(profiloOrario.giornaliero);
        mapGiornaliero.forEach((value) => sum += value.tempo);

        return calcolaTempo(sum);
    } else {
        return `${0} Ore`;
    }
};
//**************** funzioni per calcolare le ore previste nel profilo orario *****************

//**************** funzioni per la creazione del nuovo giornaliero ***************************

export function createGiornaliero({giorni, deltaPre, deltaPost}) {
    const giornaliero = {};

    if (giorni.value === 'AllDays') {
        giorni.elementConfig.options
            .filter(g => g.value !== giorni.value)
            .reduce((acc, g) => {
                acc[g.value] = createGiornalieroObj(deltaPre.value, deltaPost.value);
                return acc;
            }, giornaliero)

        /*Array.apply(null, {length: 7}).forEach((_, i) => {
            giornaliero[(i + 1).toString()] = createGiornalieroObj(deltaPre.value, deltaPost.value);
        });*/
    } else {
        giornaliero[giorni.value.toString()] = createGiornalieroObj(
            deltaPre.value,
            deltaPost.value
        );
    }
    return convertObjectToMap(giornaliero);
}


const createGiornalieroObj = (deltaPre = null, deltaPost = null, entrata = null, uscita = null, tempo = 0) => ({
    orarioEntrata: entrata,
    orarioUscita: uscita,
    deltaFlessibilitaUscitaPost: deltaPost,
    deltaFlessibilitaUscitaPre: deltaPost,
    deltaFlessibilitaEntrataPre: deltaPre,
    deltaFlessibilitaEntrataPost: deltaPre,
    tempo: (tempo * 60),
    minimoNumeroTimbrature: "2",
    pausa: {}
});

//**************** funzioni per la creazione del nuovo giornaliero ***************************

//**************** funzioni per la creazione del nuovo giornaliero ***************************

export function getStartDayMonday(startDateFromCourse, endDateFromCourse) {
    let startDay = dayJS().isBefore(startDateFromCourse) ? startDateFromCourse :
        (dayJS(endDateFromCourse, 'YYYY-MM-DD').diff(startDateFromCourse, 'days') + 1) < 7 ?
            startDateFromCourse : dayJS().format('YYYY-MM-DD');

    // 0 corrisponde a Lunedì
    if (dayJS(startDay, 'YYYY-MM-DD').weekday() !== 0) {
        if ((endDateFromCourse != null && endDateFromCourse !== '')) {
            if ((dayJS(endDateFromCourse, 'YYYY-MM-DD').diff(startDay, 'days') + 1) >= 7) {
                startDay = dayJS(startDay, 'YYYY-MM-DD').add(7 - dayJS(startDay, 'YYYY-MM-DD').weekday(), 'days').format('YYYY-MM-DD');
            } else {
                startDay = dayJS(startDay, 'YYYY-MM-DD').subtract(dayJS(startDay, 'YYYY-MM-DD').weekday(), 'days').format('YYYY-MM-DD');

                if (dayJS(startDay, 'YYYY-MM-DD').isBefore(startDateFromCourse, 'days')) {
                    startDay = startDateFromCourse;
                }
            }
        } else {
            startDay = dayJS(startDay, 'YYYY-MM-DD').add(7 - dayJS(startDay, 'YYYY-MM-DD').weekday(), 'days').format('YYYY-MM-DD');
        }
    }

    /* return (endDateFromCourse != null && endDateFromCourse !== '') ?
         dayJS(startDay, 'YYYY-MM-DD').isAfter(endDateFromCourse) ?
             endDateFromCourse : startDay
         : startDay;*/

    return startDay;

}

//**************** funzioni per la creazione del nuovo giornaliero ***************************


